import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <div className="relative bg-white rounded-3xl p-8 sm:p-12 text-center shadow-2xl overflow-hidden" data-id="element-105">
          {/* Top accent bar */}
          <div className="absolute top-0 left-0 w-full h-2 bg-[#d4af37]" data-id="element-106" />

          {/* Eyebrow badge */}
          <span className="inline-block bg-[#d4af37] text-[#0A0A0A] text-[10px] sm:text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-md mb-6" data-id="element-107">
            ✔ Zero Risk
          </span>

          {/* Shield */}
          <div className="relative inline-flex items-center justify-center mb-6" data-id="element-108">
            <div className="absolute w-24 h-24 bg-[#d4af37]/20 rounded-full blur-2xl" data-id="element-109" />
            <span className="relative text-7xl" data-id="element-110">🛡️</span>
          </div>

          <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-6 tracking-tight" data-id="element-111">
            7-Day <span className="text-[#d4af37]" data-id="element-112">Guarantee</span>
          </h2>

          <p className="text-[#5A5A66] text-lg font-medium mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-113">
            Open everything. Check every session. Use the drills.
          </p>

          <p className="text-[#0A0A0A] text-2xl sm:text-3xl font-black mb-4 leading-tight" data-id="element-114">
            Try Cricket Ready risk-free. If you're not fully satisfied,{' '}
            <br className="sm:hidden" data-id="element-115" />
            <span className="text-[#d4af37]" data-id="element-116">
              we'll refund you 100% — no questions asked.
            </span>
          </p>

          <p className="text-[#5A5A66] text-base font-bold mb-8 uppercase tracking-widest" data-id="element-117">
            No questions asked.
          </p>

          <span className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/40 text-[#d4af37] text-xs sm:text-sm font-black px-5 py-2.5 rounded-full uppercase tracking-wider" data-id="element-118">
            Refund rate below 1%
          </span>
        </div>
      </div>
    </section>;
}